export const MIN_BIRTH_YEAR = 1300;

export function currentPersianYear(now = new Date()) {
    return Number(new Intl.DateTimeFormat('en-u-ca-persian-nu-latn', {
        timeZone: 'Asia/Tehran', year: 'numeric',
    }).formatToParts(now).find(part => part.type === 'year').value);
}

export function birthYears(now = new Date()) {
    const maximum = currentPersianYear(now) + 1;
    return [{ value: -1, label: 'سال' }, ...Array.from(
        { length: maximum - MIN_BIRTH_YEAR + 1 },
        (_, index) => ({ value: maximum - index, label: maximum - index }),
    )];
}

// Esfand deliberately allows 30 days regardless of leap year.
export function maxBirthDay(month) {
    return Number(month) >= 7 && Number(month) <= 12 ? 30 : 31;
}

export function birthDays(month) {
    return [{ value: -1, label: 'روز' }, ...Array.from(
        { length: maxBirthDay(month) }, (_, index) => ({ value: index + 1, label: index + 1 }),
    )];
}

export function dayAfterMonthChange(day, month) {
    return Number(day?.value) > maxBirthDay(month) ? { value: -1, label: 'روز' } : day;
}

export function validBirthDay(day, month) {
    return Number.isInteger(Number(day)) && Number(day) >= 1 && Number(day) <= maxBirthDay(month);
}

export function validBirthYear(year, now = new Date()) {
    return Number.isInteger(Number(year)) && Number(year) >= MIN_BIRTH_YEAR && Number(year) <= currentPersianYear(now) + 1;
}
